import { render } from "./MatchingModal.vue?vue&type=template&id=6f7e0186&scoped=true"
const script = {}

import "./MatchingModal.vue?vue&type=style&index=0&id=6f7e0186&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7e0186"]])

export default __exports__